import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["textContent"]

import {computed, watch} from 'vue';
import {useClickOutside} from "../Helper/clickOutside";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";
import Blip from "./Blip.vue";
import {DrawerScroll} from "./Drawer";
import Drawer from "./Drawer.vue";
import Material from "./Material.vue";

interface Props {
  title: string;
  icon?: IconName;
  testId?: string;
  nested?: boolean;
  nestedFlush?: boolean;
  noSpace?: boolean;
  scroll: DrawerScroll;
  blip?: string;
  openToLeft?: boolean;
  hasError?: boolean;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    icon: {},
    testId: {},
    nested: { type: Boolean },
    nestedFlush: { type: Boolean },
    noSpace: { type: Boolean },
    scroll: {},
    blip: {},
    openToLeft: { type: Boolean },
    hasError: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    "open": {default: false, type: Boolean},
    "openModifiers": {},
  }),
  emits: ["update:open"],
  setup(__props: any) {

const props = __props;
const open = _useModel(__props, 'open');
const clickOutside = useClickOutside(true);

function toggle(): void {
  if (!props.disabled) {
    open.value = !open.value;
  }
}

watch(open, (newValue: boolean): void => {
  if (newValue) {
    clickOutside.addClickListener(() => open.value = false);
  } else {
    clickOutside.removeAll();
  }
});

const borderClass = computed(() => {
  if (props.nested || props.nestedFlush) {
    if (props.hasError) {
      throw new Error('Nested inputs do not have errors.');
    }
    return '';
  }
  if (props.hasError) {
    return 'border border-red-500';
  }
  return 'border border-neutral2-300';
});

const disabledClass = computed(() => {
  if (props.disabled) {
    return 'text-neutral2-400 border border-tile-border';
  }
  return 'cursor-pointer';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Material, {
    nested: props.nested,
    class: _normalizeClass(["relative", [borderClass.value, disabledClass.value]]),
    disabled: props.disabled,
    onClick: toggle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "flex items-center",
        "data-testid": props.testId
      }, [
        (props.icon)
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              name: props.icon,
              class: "mr-2"
            }, null, 8 /* PROPS */, ["name"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", {
          class: "mr-2 font-medium",
          textContent: _toDisplayString(props.title)
        }, null, 8 /* PROPS */, _hoisted_2),
        _createVNode(Icon, {
          name: "dropdownClosed",
          class: "ml-auto"
        })
      ], 8 /* PROPS */, _hoisted_1),
      (open.value)
        ? (_openBlock(), _createBlock(Drawer, {
            key: 0,
            "no-space": props.noSpace,
            scroll: props.scroll,
            "open-to-left": props.openToLeft
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["no-space", "scroll", "open-to-left"]))
        : _createCommentVNode("v-if", true),
      (props.blip)
        ? (_openBlock(), _createBlock(Blip, {
            key: 1,
            value: props.blip
          }, null, 8 /* PROPS */, ["value"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["nested", "class", "disabled"]))
}
}

})